import Layout from '@/views/layout/Layout'
const accessoriesRouter = {
    path: '/accessories',
    name: 'accessories',
    component: Layout,
    redirect: 'noRedirect',
    children: [
        // 辅料-辅料供应商+采购商路由
        {
            path: 'allcompany',
            name: 'allcompany',
            meta: { name: '全部商家'},
            component: () => import('@/views/accessories/supplier'),
        },
        // 辅料-辅料供应商路由
        {
            path: 'supplier',
            name: 'supplier',
            meta: { name: '辅料供应商'},
            component: () => import('@/views/accessories/supplier'),
        },
        // 辅料-辅料采购商路由
        {
            path: 'purchaser',
            name: 'purchaser',
            meta: { name: '辅料采购商'},
            component: () => import('@/views/accessories/supplier'),
        },
        // 辅料-产品供应路由
        {
            path: 'productSupply',
            name: 'productSupply',
            meta: { name: '所有供应产品'},
            component: () => import('@/views/accessories/productSupply'),
        },
        // 辅料-产品求购路由
        {
            path: 'productPurchase',
            name: 'productPurchase',
            meta: { name: '求购信息'},
            component: () => import('@/views/accessories/productPurchase'),
        },
        // 辅料-产品供应分类路由
        {
            path: 'productClass',
            name: 'productClass',
            meta: { name: '产品列表'},
            component: () => import('@/views/accessories/productClass'),
        },
        // 辅料-产品求购分类路由
        {
            path: 'purchaseClass',
            name: 'purchaseClass',
            meta: { name: '求购信息'},
            component: () => import('@/views/accessories/purchaseClass'),
        },
        // 辅料-产品信息路由---来自产品供应或产品求购
        {
            path: 'productInfo',
            name: 'productInfo',
            meta: { name: '产品信息详情'},
            component: () => import('@/views/accessories/productInfo'),
        },
        // 提交订单 路由
        {
            path: 'submitOrder',
            name: 'submitOrder',
            meta: { name: '提交订单'},
            component: () => import('@/views/accessories/submitOrder'),
        },
    ]
}
export default accessoriesRouter


// WEBPACK FOOTER //
// ./src/router/modules/accessories.js